import { createPinia, setActivePinia } from 'pinia';

// import { app } from '@/app';
import { SignalrPiniaPlugin } from '@/stores/plugins/SignalrPiniaPlugin/SignalrPiniaPlugin';

export const pinia = createPinia();

setActivePinia(pinia);

// Register Pinia plugins.
pinia.use(SignalrPiniaPlugin);

// Activate pinia.
// app.use(pinia); initialize in AppController.ts
